<template>
    <div class="card">
        <div class="card-header">
            <div class="row align-items-center">
                <div class="col">
                    <h4 class="card-header-title">{{$t('Root canals')}}</h4>
                </div>
                <div class="col-auto">
                    <b-button size="sm" variant="primary" @click="addRow">
                        <i class="fe fe-plus" />
                    </b-button>
                </div>
            </div>
        </div>

        <div class="card-body text-center text-muted small" v-if="channels.length == 0">{{$t('No channel measurement')}}</div>
        <div class="card-body" v-else>
            <div v-for="(channel, key) in channels" :key="key" class="row mb-2">
                <div class="col-5 pr-0">
                    <b-form-input v-model="channel.label" :placeholder="$t('Channel')"></b-form-input>
                </div>
                <div class="col-4 pr-0 pl-1">
                    <b-form-input v-model="channel.value" :placeholder="$t('Value')"></b-form-input>
                </div>
                <div class="col-2 pl-1">
                    <b-button class="btn-white" v-if="key==0" @click="addRow">
                        <i class="fe fe-plus text-muted"></i>
                    </b-button>
                    <b-button class="btn-white" v-else @click="removeRow(key)">
                        <i class="fe fe-trash text-muted"></i>
                    </b-button>
                </div>
            </div>
            <button class="btn btn-white btn-sm" @click="save">
                <i class="fe fe-save" />
            </button>
        </div>
    </div>
</template>
<script>
import debounce from 'lodash/debounce';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    props: ['value', 'tooth', 'customerId'],
    data() {
        return {
            params: {
                query: {
                    customerId: this.customerId,
                    tooth: this.tooth
                }
            },
            channels: []
        }
    },

    created() {

        this.getTooth(this.params).then(result => {

            if (result.total > 0) {
                this.channels = result.data[0].roots || [];
            } else {
                this.channels = [];
            }

        });
    },
    computed: {
        ...mapGetters('tooth', { findToothInStore: 'find' }),

        toothData() {
            let data = this.findToothInStore(this.params).data;
            if (data.length > 0) {
                return data[0];
            } else
                return { roots: [] };
        },
    },
    methods: {

        ...mapActions('tooth', { fetchTooth: 'find', updateTooth: 'patch', createTooth: 'create' }),
        getTooth() {
            return this.fetchTooth(this.params);
        },
        save() {

            let promise;
            if (this.toothData._id) {
                promise = this.updateTooth([this.toothData._id, { roots: this.channels }]);
            } else {
                promise = this.createTooth({ roots: this.channels, tooth: this.tooth, customerId: this.customerId });
            }

            promise.then(r => {
                this.$toasted.global.success({
                    message: this.$t('Roots has been saved')
                });
            });

        },
        removeRow(index) {
            this.channels.splice(index, 1);
        },
        addRow() {
            this.channels.push({
                label: this.channels.length + 1
            });
        },

    }
}
</script>